import { gql } from "apollo-boost";

export default {
    FETCH_SINGLE_CASE: gql`
        query FetchSingleCase($id: ID!) {
            fetchSingleCase(id: $id) {
                _id
                createdAt
                submissionDate
                signedDate
                approvalDate
                createdBy {
                    _id
                    name
                }
                project {
                    _id
                    name
                    developerName
                }
                status
                salesType
                salesAgent {
                    _id
                    name
                }
                applyFor
                mdgAgent {
                    _id
                    name
                }
                bank {
                    _id
                    bankName
                    bankerName
                    bankContact
                    bankEmail
                    bankSubEmail
                    status
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                    updatedAt
                    updatedBy {
                        _id
                        name
                    }
                }
                document {
                    url
                    type
                    _id
                    name
                    bankName
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
                pic {
                    _id
                    name
                }
                propertyAgent
                log {
                    _id
                    createdAt
                    remarks
                    createdBy {
                        _id
                        name
                    }
                    type
                }
                remarks {
                    _id
                    content
                    createdAt   
                    createdBy {
                        _id
                        name
                    }
                }
                unitNumber
                spaPrice
                agency {
                    _id
                    name
                }
                borrower {
                    _id
                    name
                    ic
                    contact
                    email
                    educationLevel
                    smoking
                    salary
                    motherName
                    mailingAddress
                    lengthOfStay
                    currentCompanyName
                    currentCompanyAddress
                    currentNatureBusiness
                    currentHRDirectline
                    currentYearService
                    currentPosition
                    pastCompanyName
                    pastCompanyAddress
                    pastNatureBusiness
                    pastHRDirectline
                    pastYearService
                    pastPosition
                    maritalStatus
                    occupation
                    monthlyIncome
                    childrensNo
                    emergencyName
                    emergencyContact
                    emergencyRelationship
                    emergencyAddress
                    emergencyOccupation
                    emergencyIC
                    spouseName
                    spouseNRIC
                    spouseContact
                    spouseOccupation
                    spouseCompanyName
                    spouseMonthlyIncome
                    allDetails
                }
                propertyDetails {
                    address
                    propertyType
                    completed
                    bumi
                    hold
                    buildup
                    landsize
                    renodetails
                    spaPrice
                    margin
                    loanAmount
                    loanTenure
                    propertyAgent
                }
                spaName
                spaLawyer
                laLawyer
                lawyerRemarks
                valuerName
                valuerFirm
                marketValue
                flexiType
                spaPrice
                mailHistory {
                    _id
                    createdAt
                    receiver
                    messageContent
                    status
                }
                terms {
                    _id
                    amount
                    plan
                    method
                    inforceDate
                    status
                    term
                    autosend
                    borrower
                    policyNumber
                }
                state
            }
        }
    `,

    FETCH_CASES: gql`
        query FetchCases($limit: Int!, $page: Int!, $by: String, $dir: String, $unitNumber: String, $dateFrom: String, $dateTo: String, $submissionFrom: String, $submissionTo: String, $approvalFrom: String, $approvalTo: String, $signedFrom: String, $signedTo: String, $mdgAgent: String, $state: String, $status: String, $project: String, $agency: String, $pic: String, $borrower: String, $pd: String, $sd: String, $propertyAgent: String, $shareholder: String) {
            fetchCases(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    unitNumber: $unitNumber
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    submissionFrom: $submissionFrom
                    submissionTo: $submissionTo
                    approvalFrom: $approvalFrom
                    approvalTo: $approvalTo
                    signedFrom: $signedFrom
                    signedTo: $signedTo
                    mdgAgent: $mdgAgent
                    state: $state
                    status: $status
                    project: $project
                    agency: $agency
                    pic: $pic
                    borrower: $borrower
                    pd: $pd
                    sd: $sd
                    propertyAgent: $propertyAgent
                    shareholder: $shareholder
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    createdAt
                    submissionDate
                    signedDate
                    approvalDate
                    createdBy {
                        _id
                        name
                    }
                    project {
                        _id
                        name
                        developerName
                    }
                    status
                    salesType
                    salesAgent {
                        _id
                        name
                    }
                    applyFor
                    mdgAgent {
                        _id
                        name
                    }
                    bank {
                        _id
                        bankName
                        bankerName
                        bankContact
                        bankEmail
                    bankSubEmail
                        status
                        createdAt
                        createdBy {
                            _id
                            name
                        }
                        updatedAt
                        updatedBy {
                            _id
                            name
                        }
                    }
                    document {
                        url
                        type
                        _id
                        name
                        bankName
                        createdAt
                        createdBy {
                            _id
                            name
                        }
                    }
                    pic {
                        _id
                        name
                    }
                    log {
                        _id
                        createdAt
                        remarks
                        createdBy {
                            _id
                            name
                        }
                        type
                    }
                    remarks {
                        _id
                        content
                        createdAt   
                        createdBy {
                            _id
                            name
                        }
                    }
                    unitNumber
                    spaPrice
                    agency {
                        _id
                        name
                    }
                    propertyAgent
                    borrower {
                        _id
                        name
                        ic
                        contact
                        email
                        educationLevel
                        smoking
                        motherName
                        mailingAddress
                        lengthOfStay
                        salary
                        currentCompanyName
                        currentCompanyAddress
                        currentNatureBusiness
                        currentHRDirectline
                        currentYearService
                        currentPosition
                        pastCompanyName
                        pastCompanyAddress
                        pastNatureBusiness
                        pastHRDirectline
                        pastYearService
                        pastPosition
                        maritalStatus
                        occupation
                        monthlyIncome
                        childrensNo
                        emergencyName
                        emergencyContact
                        emergencyRelationship
                        emergencyAddress
                        emergencyOccupation
                        emergencyIC
                        spouseName
                        spouseNRIC
                        spouseContact
                        spouseOccupation
                        spouseCompanyName
                        spouseMonthlyIncome
                        allDetails
                    }
                    propertyDetails {
                        address
                        propertyType
                        completed
                        bumi
                        hold
                        buildup
                        landsize
                        renodetails
                        spaPrice
                        margin
                        loanAmount
                        loanTenure
                        propertyAgent
                    }
                    spaName
                    spaLawyer
                    laLawyer
                    lawyerRemarks
                    valuerName
                    valuerFirm
                    marketValue
                    flexiType
                    spaPrice
                    mailHistory {
                        _id
                        createdAt
                        receiver
                        messageContent
                        status
                    }
                    terms {
                        _id
                        amount
                        plan
                        method
                        inforceDate
                        status
                        term
                        autosend
                        borrower
                        policyNumber
                    }
                    state
                }
            }
        }
    `,


    CREATE_CASE: gql`
        mutation CreateCase(
            $agency: String
            $applyFor: String
            $flexiType: String
            $spaName: [String]
            $spaLawyer: String
            $laLawyer: String
            $valuerName: String
            $valuerFirm: String
            $marketValue: String
            $submissionDate: String
            $createdAt: String
            $status: String!
            $project: ID
            $unitNumber: String
            $salesAgent: ID
            $pic: ID
            $mdgAgent: ID
            $nfcAgentOptional: ID
            $salesType: String
            $remarks: String
            $spaPrice: String
            $state: String
            $propertyAgent: String
            $propertyDetails: PropertyDetailsInput
            $borrower: [BorrowerInput]
            $lawyerRemarks: String
        ) {
            createCase(
                input: {
                    applyFor: $applyFor
                    submissionDate: $submissionDate
                    createdAt: $createdAt
                    project: $project
                    status: $status
                    salesAgent: $salesAgent
                    pic: $pic
                    mdgAgent: $mdgAgent
                    propertyAgent: $propertyAgent
                    unitNumber: $unitNumber
                    spaPrice: $spaPrice
                    agency: $agency
                    salesType: $salesType
                    remarks: $remarks
                    state: $state
                    propertyDetails: $propertyDetails
                    flexiType: $flexiType
                    spaName: $spaName
                    spaLawyer: $spaLawyer
                    laLawyer: $laLawyer
                    marketValue: $marketValue
                    valuerName: $valuerName
                    valuerFirm: $valuerFirm
                    borrower: $borrower
                    nfcAgentOptional: $nfcAgentOptional
                    lawyerRemarks: $lawyerRemarks
                }
            ) {
                _id
                log {
                    _id
                    type
                    remarks
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,

    UPDATE_CASE: gql`
        mutation UpdateCase(
            $_id: ID!
            $agency: String
            $applyFor: String
            $flexiType: String
            $lawyerFirm: String
            $marketValue: String
            $valuerName: String
            $valuerFirm: String
            $submissionDate: String
            $signedDate: String
            $approvalDate: String
            $createdAt: String
            $status: String!
            $project: ID
            $unitNumber: String!
            $salesAgent: ID
            $pic: ID
            $mdgAgent: ID
            $propertyAgent: String
            $nfcAgentOptional: ID
            $salesType: String
            $lawyerRemarks: String
            $spaPrice: String
            $state: String
            $propertyDetails: PropertyDetailsInput
            $spaName: [String]
            $spaLawyer: String
            $laLawyer: String
            $borrower: [BorrowerInput]
        ) {
            updateCase(
                input: {
                    _id: $_id
                    project: $project
                    status: $status
                    salesAgent: $salesAgent
                    pic: $pic
                    mdgAgent: $mdgAgent
                    propertyAgent: $propertyAgent
                    unitNumber: $unitNumber
                    spaPrice: $spaPrice
                    agency: $agency
                    state: $state
                    propertyDetails: $propertyDetails
                    applyFor: $applyFor
                    flexiType: $flexiType
                    lawyerFirm: $lawyerFirm
                    borrower: $borrower
                    spaName: $spaName
                    spaLawyer: $spaLawyer
                    laLawyer: $laLawyer
                    marketValue: $marketValue
                    valuerName: $valuerName
                    valuerFirm: $valuerFirm
                    salesType: $salesType
                    nfcAgentOptional: $nfcAgentOptional
                    submissionDate: $submissionDate
                    signedDate: $signedDate
                    approvalDate: $approvalDate
                    createdAt: $createdAt
                    lawyerRemarks: $lawyerRemarks
                }
            ) {
                _id
                    createdAt
                    submissionDate
                    signedDate
                    approvalDate
                    createdBy {
                        _id
                        name
                    }
                    project {
                        _id
                        name
                        developerName
                    }
                    status
                    salesType
                    salesAgent {
                        _id
                        name
                    }
                    applyFor
                    mdgAgent {
                        _id
                        name
                    }
                    bank {
                        _id
                        bankName
                        bankerName
                        bankContact
                        bankEmail
                    bankSubEmail
                        status
                        createdAt
                        createdBy {
                            _id
                            name
                        }
                        updatedAt
                        updatedBy {
                            _id
                            name
                        }
                    }
                    document {
                        url
                        type
                        _id
                        name
                        bankName
                        createdAt
                        createdBy {
                            _id
                            name
                        }
                    }
                    pic {
                        _id
                        name
                    }
                    propertyAgent
                    log {
                        _id
                        createdAt
                        remarks
                        createdBy {
                            _id
                            name
                        }
                        type
                    }
                    remarks {
                        _id
                        content
                        createdAt   
                        createdBy {
                            _id
                            name
                        }
                    }
                    unitNumber
                    spaPrice
                    agency {
                        _id
                        name
                    }
                    borrower {
                        _id
                        name
                        ic
                        contact
                        email
                        educationLevel
                        smoking
                        motherName
                        mailingAddress
                        lengthOfStay
                        salary
                        currentCompanyName
                        currentCompanyAddress
                        currentNatureBusiness
                        currentHRDirectline
                        currentYearService
                        currentPosition
                        pastCompanyName
                        pastCompanyAddress
                        pastNatureBusiness
                        pastHRDirectline
                        pastYearService
                        pastPosition
                        maritalStatus
                        occupation
                        monthlyIncome
                        childrensNo
                        emergencyName
                        emergencyContact
                        emergencyRelationship
                        emergencyAddress
                        emergencyOccupation
                        emergencyIC
                        spouseName
                        spouseNRIC
                        spouseContact
                        spouseOccupation
                        spouseCompanyName
                        spouseMonthlyIncome
                        allDetails
                    }
                    propertyDetails {
                        address
                        propertyType
                        completed
                        bumi
                        hold
                        buildup
                        landsize
                        renodetails
                        spaPrice
                        margin
                        loanAmount
                        loanTenure
                        propertyAgent
                    }
                    spaName
                    spaLawyer
                    laLawyer
                    lawyerRemarks
                    valuerName
                    valuerFirm
                    marketValue
                    flexiType
                    spaPrice
                    mailHistory {
                        _id
                        createdAt
                        receiver
                        messageContent
                        status
                    }
                    terms {
                        _id
                        amount
                        plan
                        method
                        inforceDate
                        status
                        term
                        autosend
                        borrower
                        policyNumber
                    }
                    state
            }
        }
    `,

    ADD_REMARK: gql`
        mutation AddRemark($caseId: ID!, $content: String!) {
            addRemark(input: { caseId: $caseId, content: $content }) {
                _id
                remarks {
                    content
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,

    FETCH_AGENCIES: gql`
        query FetchAgencies(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $name: String
            $status: String
            $_id: String
        ) {
            fetchAgencies(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    _id: $_id
                    name: $name
                    status: $status
                }
            ) {
                data {
                    _id
                    name
                }
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
            }
        }
    `,
    CREATE_AGENCY: gql`
        mutation CreateAgency($input: CreateAgencyInput!) {
            createAgency(input: $input) {
                _id
                name
            }
        }
    `,
    DELETE_AGENCY: gql`
        mutation DeleteAgency($input: DeleteAgencyInput!) {
            deleteAgency(input: $input) {
                _id
            }
        }
    `,
    UPDATE_AGENCY: gql`
        mutation UpdateAgency($input: UpdateAgencyInput!) {
            updateAgency(input: $input) {
                _id
                name
            }
        }
    `,
    SEND_EMAIL: gql`
        mutation SendEmail($email: String!, $caseId: ID!, $bankId: ID) {
            sendEmail(input: { email: $email, caseId: $caseId, bankId: $bankId }) {
                _id
               mailHistory {
                createdAt
                receiver
                messageContent
                status
               }
            }
        }
    `,
    CREATE_LOG: gql`
        mutation CreateLog($case: ID!, $remarks: String!) {
            createLog(input: { case: $case, remarks: $remarks }) {
                _id
            }
        }
    `,
    ADD_DOCUMENT: gql`
        mutation AddDocument(
            $caseId: ID!
            $url: String!
            $name: String
            $type: String!
            $bankName: String!
        ) {
            addDocument(
                input: { caseId: $caseId, url: $url, type: $type, name: $name, bankName: $bankName }
            ) {
                _id
                document {
                    url
                    type
                    _id
                    name
                    bankName
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
                log {
                    _id
                    type
                    remarks
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,

    UPDATE_CASE_STATUS: gql`
        mutation UpdateCaseStatus($id: ID!, $status: CaseStatusTypeEnum!) {
            updateCaseStatus(input: { id: $id, status: $status }) {
                    _id
                    createdAt
                    submissionDate
                    signedDate
                    approvalDate
                    createdBy {
                        _id
                        name
                    }
                    project {
                        _id
                        name
                        developerName
                    }
                    status
                    salesType
                    salesAgent {
                        _id
                        name
                    }
                    applyFor
                    mdgAgent {
                        _id
                        name
                    }
                    bank {
                        _id
                        bankName
                        bankerName
                        bankContact
                        bankEmail
                    bankSubEmail
                        status
                        createdAt
                        createdBy {
                            _id
                            name
                        }
                        updatedAt
                        updatedBy {
                            _id
                            name
                        }
                    }
                    document {
                        url
                        type
                        _id
                        name
                        bankName
                        createdAt
                        createdBy {
                            _id
                            name
                        }
                    }
                    pic {
                        _id
                        name
                    }
                    propertyAgent
                    log {
                        _id
                        createdAt
                        remarks
                        createdBy {
                            _id
                            name
                        }
                        type
                    }
                    remarks {
                        _id
                        content
                        createdAt   
                        createdBy {
                            _id
                            name
                        }
                    }
                    unitNumber
                    spaPrice
                    agency {
                        _id
                        name
                    }
                    borrower {
                        _id
                        name
                        ic
                        contact
                        email
                        educationLevel
                        smoking
                        motherName
                        mailingAddress
                        lengthOfStay
                        salary
                        currentCompanyName
                        currentCompanyAddress
                        currentNatureBusiness
                        currentHRDirectline
                        currentYearService
                        currentPosition
                        pastCompanyName
                        pastCompanyAddress
                        pastNatureBusiness
                        pastHRDirectline
                        pastYearService
                        pastPosition
                        maritalStatus
                        occupation
                        monthlyIncome
                        childrensNo
                        emergencyName
                        emergencyContact
                        emergencyRelationship
                        emergencyAddress
                        emergencyOccupation
                        emergencyIC
                        spouseName
                        spouseNRIC
                        spouseContact
                        spouseOccupation
                        spouseCompanyName
                        spouseMonthlyIncome
                        allDetails
                    }
                    propertyDetails {
                        address
                        propertyType
                        completed
                        bumi
                        hold
                        buildup
                        landsize
                        renodetails
                        spaPrice
                        margin
                        loanAmount
                        loanTenure
                        propertyAgent
                    }
                    spaName
                    spaLawyer
                    laLawyer
                    lawyerRemarks
                    valuerName
                    valuerFirm
                    marketValue
                    flexiType
                    spaPrice
                    mailHistory {
                        _id
                        createdAt
                        receiver
                        messageContent
                        status
                    }
                    terms {
                        _id
                        amount
                        plan
                        method
                        inforceDate
                        status
                        term
                        autosend
                        borrower
                        policyNumber
                    }
                    state
                }
    
        }
    `,

    UPDATE_BANK_STATUS: gql`
        mutation UpdateBankStatus(
            $caseId: ID!
            $bankId: ID!
            $bankerName: String
            $bankContact: String
            $bankEmail: String
            $bankSubEmail: [String]
            $status: String!
        ) {
            updateBankStatus(
                input: { caseId: $caseId, bankId: $bankId, status: $status, bankerName: $bankerName, bankContact: $bankContact, bankEmail: $bankEmail, bankSubEmail: $bankSubEmail }
            ) {
                _id
                bank {
                    _id
                    bankName
                    bankerName
                    bankContact
                    bankEmail
                    bankSubEmail
                    status
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                    updatedAt
                    updatedBy {
                        _id
                        name
                    }
                }
                log {
                    _id
                    type
                    remarks
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,

    ADD_BANK: gql`
        mutation AddBank($caseId: ID!, $bankName: String!, $status: String!, $bankContact: String!, $bankEmail: String!, $bankSubEmail: [String], $bankerName: String!) {
            addBank(
                input: { caseId: $caseId, bankName: $bankName, status: $status, bankContact: $bankContact, bankEmail: $bankEmail, bankSubEmail: $bankSubEmail, bankerName: $bankerName }
            ) {
                _id
                bank {
                    _id
                    bankName
                    status
                    bankContact
                    bankEmail
                    bankSubEmail
                    bankerName
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                    updatedAt
                    updatedBy {
                        _id
                        name
                    }
                }
                log {
                    _id
                    type
                    remarks
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,
    ADD_BORROWER_TO_CASE: gql`
        mutation AddBorrowerToCase(
            $_id: ID!
            $name: String!
            $ic: String!
            $contact: String!
            $email: String!
            $educationLevel: String!
            $smoking: String!
            $motherName: String!
            $mailingAddress: String!
            $lengthOfStay: String!
            $currentCompanyName: String!
            $currentCompanyAddress: String!
            $currentNatureBusiness: String!
            $currentHRDirectline: String!
            $currentJoiningDate: String!
            $currentPosition: String!
            $pastCompanyName: String!
            $pastCompanyAddress: String!
            $pastNatureBusiness: String!
            $pastPhone: String!
            $pastYearService: String!
            $pastPosition: String!
            $maritalStatus: String!
            $occupation: String!
            $monthlyIncome: String!
            $childrensNo: String!
            $emergencyName: String!
            $emergencyContact: String!
            $emergencyRelationship: String!
            $emergencyAddress: String!
            $emergencyOccupation: String!
        ) {
            addBorrowerToCase(
                input: {
                    _id: $_id
                    name: $name
                    ic: $ic
                    contact: $contact
                    email: $email
                    educationLevel: $educationLevel
                    smoking: $smoking
                    motherName: $motherName
                    mailingAddress: $mailingAddress
                    lengthOfStay: $lengthOfStay
                    currentCompanyName: $currentCompanyName
                    currentCompanyAddress: $currentCompanyAddress
                    currentNatureBusiness: $currentNatureBusiness
                    currentHRDirectline: $currentHRDirectline
                    currentJoiningDate: $currentJoiningDate
                    currentPosition: $currentPosition
                    pastCompanyName: $pastCompanyName
                    pastCompanyAddress: $pastCompanyAddress
                    pastNatureBusiness: $pastNatureBusiness
                    pastPhone: $pastPhone
                    pastYearService: $pastYearService
                    pastPosition: $pastPosition
                    maritalStatus: $maritalStatus
                    occupation: $occupation
                    monthlyIncome: $monthlyIncome
                    childrensNo: $childrensNo
                    emergencyName: $emergencyName
                    emergencyContact: $emergencyContact
                    emergencyRelationship: $emergencyRelationship
                    emergencyAddress: $emergencyAddress
                    emergencyOccupation: $emergencyOccupation
                }
            ) {
                _id
                createdAt
                submissionDate
                createdBy {
                    _id
                    name
                }
                project {
                    _id
                    name
                    developerName
                }
                status
                salesType
                salesAgent {
                    _id
                    name
                }
                applyFor
                mdgAgent {
                    _id
                    name
                }
                bank {
                    _id
                    bankName
                    status
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                    updatedAt
                    updatedBy {
                        _id
                        name
                    }
                }
                document {
                    url
                    type
                    _id
                    name
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
                pic {
                    _id
                    name
                }
                propertyAgent
                approvalDate
                unitNumber
                spaPrice
                agency
                remarks {
                    content
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
                borrower {
                    _id
                    name
                    ic
                    contact
                    email
                    educationLevel
                    smoking
                    motherName
                    mailingAddress
                    lengthOfStay
                    currentCompanyName
                    currentCompanyAddress
                    currentNatureBusiness
                    currentHRDirectline
                    currentJoiningDate
                    currentPosition
                    pastCompanyName
                    pastCompanyAddress
                    pastNatureBusiness
                    pastPhone
                    pastYearService
                    pastPosition
                    maritalStatus
                    occupation
                    monthlyIncome
                    salary
                    childrensNo
                    emergencyName
                    emergencyContact
                    emergencyRelationship
                    emergencyAddress
                    emergencyOccupation
                    allDetails
                }
                propertyDetails {
                    address
                    propertyType
                    completed
                    bumi
                    hold
                    buildup
                    renodetails
                    spaPrice
                    margin
                    loanAmount
                    loanTenure
                }
                lawyerFirm 
                spaDate
                LODate
                LADate
                lawyerRemarks
                valuerName
                marketValue
                flexiType
                
                state
            }
        }
    `,
    EDIT_BORROWER: gql`
        mutation EditBorrower(
            $_id: ID!
            $name: String!
            $ic: String!
            $contact: String!
            $email: String!
            $educationLevel: String!
            $smoking: String!
            $motherName: String!
            $mailingAddress: String!
            $lengthOfStay: String!
            $currentCompanyName: String!
            $currentCompanyAddress: String!
            $currentNatureBusiness: String!
            $currentHRDirectline: String!
            $currentJoiningDate: String!
            $currentPosition: String!
            $pastCompanyName: String!
            $pastCompanyAddress: String!
            $pastNatureBusiness: String!
            $pastPhone: String!
            $pastYearService: String!
            $pastPosition: String!
            $maritalStatus: String!
            $occupation: String!
            $monthlyIncome: String!
            $childrensNo: String!
            $emergencyName: String!
            $emergencyContact: String!
            $emergencyRelationship: String!
            $emergencyAddress: String!
            $emergencyOccupation: String!
            $borrowerId: String!
        ) {
            editBorrower(
                input: {
                    _id: $_id
                    borrowerId: $borrowerId
                    name: $name
                    ic: $ic
                    contact: $contact
                    email: $email
                    educationLevel: $educationLevel
                    smoking: $smoking
                    motherName: $motherName
                    mailingAddress: $mailingAddress
                    lengthOfStay: $lengthOfStay
                    currentCompanyName: $currentCompanyName
                    currentCompanyAddress: $currentCompanyAddress
                    currentNatureBusiness: $currentNatureBusiness
                    currentHRDirectline: $currentHRDirectline
                    currentJoiningDate: $currentJoiningDate
                    currentPosition: $currentPosition
                    pastCompanyName: $pastCompanyName
                    pastCompanyAddress: $pastCompanyAddress
                    pastNatureBusiness: $pastNatureBusiness
                    pastPhone: $pastPhone
                    pastYearService: $pastYearService
                    pastPosition: $pastPosition
                    maritalStatus: $maritalStatus
                    occupation: $occupation
                    monthlyIncome: $monthlyIncome
                    childrensNo: $childrensNo
                    emergencyName: $emergencyName
                    emergencyContact: $emergencyContact
                    emergencyRelationship: $emergencyRelationship
                    emergencyAddress: $emergencyAddress
                    emergencyOccupation: $emergencyOccupation
                }
            ) {
                _id
                createdAt
                submissionDate
                createdBy {
                    _id
                    name
                }
                status
                salesType
                salesAgent {
                    _id
                    name
                }
                applyFor
                mdgAgent {
                    _id
                    name
                }
                bank {
                    _id
                    bankName
                    status
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                    updatedAt
                    updatedBy {
                        _id
                        name
                    }
                }
                document {
                    url
                    type
                    _id
                    name
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
                pic {
                    _id
                    name
                }
                propertyAgent
                approvalDate
                unitNumber
                spaPrice
                agency
                remarks {
                    content
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
                borrower {
                    _id
                    name
                    ic
                    contact
                    email
                    educationLevel
                    smoking
                    motherName
                    mailingAddress
                    lengthOfStay
                    currentCompanyName
                    currentCompanyAddress
                    currentNatureBusiness
                    currentHRDirectline
                    currentJoiningDate
                    currentPosition
                    pastCompanyName
                    pastCompanyAddress
                    pastNatureBusiness
                    pastPhone
                    pastYearService
                    pastPosition
                    maritalStatus
                    occupation
                    monthlyIncome
                    salary
                    childrensNo
                    emergencyName
                    emergencyContact
                    emergencyRelationship
                    emergencyAddress
                    emergencyOccupation
                    allDetails
                }
                propertyDetails {
                    address
                    propertyType
                    completed
                    bumi
                    hold
                    buildup
                    landsize
                    renodetails
                    spaPrice
                    margin
                    loanAmount
                    loanTenure
                }
                lawyerFirm {
                    spaName
                    spaLawyer
                    laLawyer
                    remarks
                }
                state
            }
        }
    `,


    DELETE_BORROWER: gql`
        mutation DeleteBorrower($caseId: ID!, $borrowerId: ID!) {
            deleteBorrower(
                input: { caseId: $caseId, borrowerId: $borrowerId }
            ) {
                _id
                borrower {
                    _id
                    name
                    ic
                    contact
                    email
                    educationLevel
                    smoking
                    motherName
                    mailingAddress
                    lengthOfStay
                    salary
                    currentCompanyName
                    currentCompanyAddress
                    currentNatureBusiness
                    currentHRDirectline
                    currentYearService
                    currentPosition
                    pastCompanyName
                    pastCompanyAddress
                    pastNatureBusiness
                    pastHRDirectline
                    pastYearService
                    pastPosition
                    maritalStatus
                    occupation
                    monthlyIncome
                    childrensNo
                    emergencyName
                    emergencyContact
                    emergencyRelationship
                    emergencyAddress
                    emergencyOccupation
                    emergencyIC
                    spouseName
                    spouseNRIC
                    spouseContact
                    spouseOccupation
                    spouseCompanyName
                    spouseMonthlyIncome
                    allDetails
                }
                document {
                    _id
                    url
                    type
                    name
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,
    DELETE_DOCUMENT: gql`
        mutation DeleteDocument($caseId: ID!, $documentId: ID!) {
            deleteDocument(
                input: { caseId: $caseId, documentId: $documentId }
            ) {
                _id
                document {
                    _id
                    url
                    type
                    name
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,

    DELETE_BANK: gql`
        mutation DeleteBank($caseId: ID!, $bankId: ID!) {
            deleteBank(input: { caseId: $caseId, bankId: $bankId }) {
                _id
                bank {
                    _id
                    bankName
                    status
                    createdAt
                    createdBy {
                        _id
                        name
                    }
                    updatedAt
                    updatedBy {
                        _id
                        name
                    }
                }
            }
        }
    `,

    ADD_MDG_AGENT: gql`
        mutation AddMdgAgent($caseId: ID!, $mdgAgentId: ID!) {
            addMdgAgent(input: { caseId: $caseId, mdgAgentId: $mdgAgentId }) {
                _id
            }
        }
    `,

    DELETE_MDG_AGENT: gql`
        mutation DeleteMdgAgent($caseId: ID!, $mdgAgentId: ID!) {
            deleteMdgAgent(input: { caseId: $caseId, mdgAgentId: $mdgAgentId }) {
                _id
            }
        }
    `,
    FETCH_PROJECTS: gql`
    query FetchProjects(
        $limit: Int!
        $page: Int!
        $name: String
        $projectDirector: ID
        $salesDirector: ID
        $propertyAgent: ID
        $project: ID
        $status: String
        $developer: String
    ) {
        fetchProjects(
            filter: {
                name: $name
                projectDirector: $projectDirector
                salesDirector: $salesDirector
                propertyAgent: $propertyAgent
                status: $status
                project: $project
                developer: $developer
            }
            pagination: { limit: $limit, page: $page }
        ) {
            data {
                _id
                name
                developerName
                projectDirector {
                    _id
                    name
                }
                salesDirector {
                    _id
                    name
                }
                propertyAgent {
                    _id
                    name
                }
            }
            pagination {
                documents
                totalPages
                page
                limit
                by
                dir
            }
        }
    }
`,
    CREATE_PROJECT: gql`
        mutation CreateProject($input: CreateProjectInput!) {
            createProject(input: $input) {
                _id
                name
                developerName
                projectDirector {
                    _id
                    name
                }
                salesDirector {
                    _id
                    name
                }
                propertyAgent {
                    _id
                    name
                }
            }
        }
    `,

    UPDATE_PROJECT: gql`
        mutation UpdateProject($input: UpdateProjectInput!) {
            updateProject(input: $input) {
                _id
                name
                developerName
                projectDirector {
                    _id
                    name
                }
                salesDirector {
                    _id
                    name
                }
                propertyAgent {
                    _id
                    name
                }
            }
        }
    `,

    DELETE_PROJECT: gql`
        mutation DeleteProject($input: DeleteProjectInput!) {
            deleteProject(input: $input) {
                _id
            }
        }
    `,

    FETCH_TERMS: gql`
        query FetchTerms(
            $limit: Int!
            $page: Int!
            $plan: String
            $method: String
            $inforceDate: Boolean
            $inforceFrom: String
            $inforceTo: String
            $submissionFrom: String
            $submissionTo: String
            $status: String
            $mdgAgent: String
        ) {
            fetchTerms(
                filter: {
                    plan: $plan
                    method: $method
                    inforceDate: $inforceDate
                    inforceFrom: $inforceFrom
                    inforceTo: $inforceTo
                    submissionFrom: $submissionFrom
                    submissionTo: $submissionTo
                    status: $status
                    mdgAgent: $mdgAgent
                }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    amount
                    term
                    plan
                    method
                    inforceDate
                    status
                    autosend
                    borrower
                    policyNumber
                    createdAt
                    case {
                        unitNumber
                        _id
                        borrower {
                            _id
                            name
                        }
                        project {
                            _id
                            name
                        }
                        agency {
                            _id
                            name
                        }
                    }
                }
            }
        }
    `,

    CREATE_TERM: gql`
        mutation CreateTerm($input: CreateTermInput!) {
            createTerm(input: $input) {
                _id
                amount
                term
                plan
                method
                inforceDate
                status
                manualYear
                autosend
                borrower
                policyNumber
            }
        }
    `,
    FETCH_COMMISSIONS: gql`
        query FetchCommissions(
            $status: String
            $type: String
            $limit: Int!
            $page: Int!
            $projectDirector: ID
            $salesDirector: ID
            $shareholder: ID
            $propertyAgent: String
            $borrower: String
            $dateFrom: String
            $dateTo: String
            $inforceFrom: String
            $inforceTo: String
            $submissionFrom: String
            $submissionTo: String
            $policyNumber: String
            $agency: ID
        ) {
            fetchCommissions(
                filters: {
                    type: $type
                    status: $status
                    projectDirector: $projectDirector
                    salesDirector: $salesDirector
                    shareholder: $shareholder
                    propertyAgent: $propertyAgent
                    borrower: $borrower
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    inforceFrom: $inforceFrom
                    inforceTo: $inforceTo
                    submissionFrom: $submissionFrom
                    submissionTo: $submissionTo
                    policyNumber: $policyNumber
                    agency: $agency
                }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                totals {
                    count
                    amount
                    termAmount
                    totalTerms
                }
                data {
                    createdAt
                    _id
                    amount
                    term {
                        _id
                        amount
                        status
                        borrower
                        policyNumber
                        inforceDate
                        method
                        plan
                        term
                        createdAt
                    }
                    status
                    type
                    user {
                        _id
                        name
                    }
                    case {
                        unitNumber
                        _id
                        submissionDate
                        propertyAgent
                        borrower {
                            _id
                            name
                        }
                        project {
                            _id
                            name
                        }
                        agency {
                            _id
                            name
                        }
                    }
                }
            }
        }
    `,


    UPDATE_COMMISSION: gql`
        mutation UpdateCommission($input: UpdateCommissionInput!) {
            updateCommission(input: $input) {
                _id
                amount
                term {
                    _id
                    policyNumber
                    amount
                    term
                    inforceDate
                    status
                    method
                    plan
                }
                status
            }
        }
    `,

    DELETE_COMMISSION: gql`
    mutation DeleteCommission($input: DeleteCommissionInput!) {
        deleteCommission(input: $input) {
            _id
        }
    }
`,

    ADD_TERM: gql`
        mutation AddTerm($caseId: ID!, $plan: String!, $amount: Float!, $method: String!, $term: Int!, $inforceDate: String!) {
            addTerm(input: {
                caseId: $caseId,
                plan: $plan,
                amount: $amount,
                method: $method,
                term: $term,
                inforceDate: $inforceDate
            }) {
                terms {
                    _id
                    plan
                    amount
                    method
                    term
                    inforceDate
                    status
                }
                log {
                    _id
                    type
                    remarks
                    createdAt
                    createdBy {
                        name
                    }
                }
            }
        }
    `,

    UPDATE_TERM: gql`
        mutation UpdateTerm( $_id: ID!, $plan: String, $amount: Float, $method: String, $term: Int, $inforceDate: String, $status: String, $autosend: Boolean) {
            updateTerm(input: {
                _id: $_id,
                plan: $plan,
                amount: $amount,
                method: $method,
                term: $term,
                inforceDate: $inforceDate,
                status: $status,
                autosend: $autosend
            }) {
                _id
                plan
                amount
                method
                term
                inforceDate
                status  
                autosend
                borrower
                policyNumber
            }
        }
    `,

    DELETE_TERM: gql`
        mutation DeleteTerm($_id: ID!) {
            deleteTerm(input: {
                _id: $_id
            }) {
                _id
            }
        }
    `,
    

    DELETE_REMARK: gql`
        mutation DeleteRemark($caseId: ID!, $remarkId: ID!) {
            deleteRemark(input: { caseId: $caseId, remarkId: $remarkId }) {
                _id
                remarks {
                    _id
                    content
                    createdAt   
                    createdBy {
                        _id
                        name
                    }
                }
            }
        }
    `,
};
